import { Icon, P, Text } from '@mxenabled/mxui'

import { Button, Card, Stack } from '@mui/material'

import { ThemedSVGImage } from '../ThemedSVGImage'
import { ReactComponent as ErrorViewCibc } from './images/ErrorViewCibc.svg'
import { BlobSVG } from '../../../../common/components/Error'

interface ErrorCardProps {
  buttonText: string
  errorText: string
  errorDescription: string
  isCibc?: boolean
}

export const ErrorCard = ({
  buttonText,
  errorText,
  errorDescription,
  isCibc = false,
}: ErrorCardProps) => {
  return (
    <Card sx={{ py: 32, px: 16 }}>
      <Stack sx={{ gap: 16, alignItems: 'center' }}>
        {isCibc ? (
          <ThemedSVGImage
            divProps={{ style: { maxWidth: 150, width: '100%' } }}
            image={ErrorViewCibc}
          />
        ) : (
          <Stack
            sx={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ThemedSVGImage
              divProps={{ style: { position: 'absolute', zIndex: 0 } }}
              image={BlobSVG}
            />
            <Icon color="primary" name={'error'} size={48} sx={{ zIndex: 1 }} />
          </Stack>
        )}

        <Stack sx={{ alignItems: 'center', gap: 2 }}>
          <Text bold={true} variant="body1">
            {errorText}
          </Text>
          <P sx={{ fontWeight: 400, textAlign: 'center' }} variant="subtitle2">
            {errorDescription}
          </P>
          <Button
            color="primary"
            onClick={() => window.location.reload()}
            sx={{ mt: '12px' }}
            variant="text"
          >
            {buttonText}
          </Button>
        </Stack>
      </Stack>
    </Card>
  )
}
